export default __webpack_public_path__ + "static/icon-outsourcing-4a7df3b1feeb7be86e584f5937de2806.png";